<template>
  <v-card>
    <slot name="title"></slot>
    <v-card-text>
      <v-container grid-list-md no-padding>
        <slot name="body"></slot>
        <v-form v-model="invoiceValid" ref="invoiceForm">
          <v-layout row wrap>
            <v-flex xs12>
              <v-radio-group
                  v-model="invoice.type"
                  :column="false"
                  class="mb-10"
              >
                <v-radio
                    :label="`app.private_person` | trans"
                    :value="`private_person`"
                    :color="`success`"
                ></v-radio>
                <v-radio
                    :label="`app.company` | trans"
                    :value="`company`"
                    :color="`success`"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  v-model="invoice.name"
                  :label="invoice.type === 'company' ? `app.company`: `app.first_name_and_last_name` | trans"
                  :rules="invoice.type === 'company' ? rules.company : rules.name"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  v-model="invoice.street_address"
                  :label="`app.street_and_number` | trans"
                  :rules="rules.street_address"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  v-model="invoice.postal_code"
                  :label="`app.postal_code` | trans"
                  :rules="rules.postal_code"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  v-model="invoice.city"
                  :label="`app.city` | trans"
                  :rules="rules.city"
                  required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                  v-model="invoice.country"
                  :items="countries"
                  item-text="name"
                  item-value="code"
                  :label="`app.country` | trans"
                  :rules="rules.country"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  v-if="invoice.type === 'company'"
                  v-model="invoice.nip"
                  :label="`app.nip` | trans"
                  :rules="rules.nip"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
      <v-btn color="primary" @click="updateInvoice()" :disabled="!invoiceValid" :loading="isLoading">
        {{ 'app.save' | trans }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {trans} from "../../../app";
import {mapActions, mapGetters} from "vuex";

export default {
  data: () => ({
    invoiceValid: false,
    invoice: {},
    isLoading: false,
  }),
  methods: {
    ...mapActions(['fetchSettings']),
    async updateInvoice() {
      this.$refs.invoiceForm.validate();
      if (!this.invoiceValid) {
        return;
      }

      this.isLoading = true;
      const previousNip = this.invoice.nip;

      try {

        if (this.invoice.type === 'private_person') {
          this.invoice.nip = null;
        }
        await axios.put('/settings/invoice', this.invoice);
        this.$toast.success(trans('app.actions.saved', {name: trans('app.pages.settings.index').toLowerCase()}));
        this.$emit('saved', {invoice: this.invoice});
      } catch (error) {
        this.invoice.nip = previousNip;
        if (error.response && error.response.status === 422) {
          this.$toast.error(trans('app.save_failed'));
        } else {
          this.sentryCaptureException(error);
        }
      }
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters(['countries']),
    rules() {
      return {
        name: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.name.required'),
        ],
        company: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.company.required'),
        ],
        street_address: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.street_address.required'),
        ],
        postal_code: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.postal_code.required'),
        ],
        city: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.city.required'),
        ],
        nip: [
          v => (this.invoice.type === 'private_person' ? true : !!v) || trans('app.settings.validation.orders_and_invoices.nip.required'),
        ],
        country: [
          v => !!v || trans('app.settings.validation.orders_and_invoices.country.required'),
        ]
      }
    }
  },
  created() {
    this.fetchSettings()
        .then(() => {
          this.invoice = this.$store.state.settings.invoice;
          if (typeof this.invoice.country === 'undefined') {
            this.invoice.country = 'PL';
          }
        }).catch((error) => {
      this.sentryCaptureException(error);
    });
  }
}
</script>